import React, { useEffect } from "react";
import { Form, InputNumber, DatePicker, Typography, Select } from "antd";
import PropTypes from "prop-types";
import { deduction, earings, setDetails } from "./index.config";
import dayjs from "dayjs";

const { Title } = Typography;

const SalaryForm = ({ form, data, selectedDate, isEdit }) => {
  useEffect(() => {
    if (data) {
      setDetails(
        isEdit ? data?.paymentDetails : data?.previousSlip,
        form,
        selectedDate,
        isEdit
      );
    }
  }, [data, form]);

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        month: dayjs(selectedDate),
        basicPay: 0,
        hra: 0,
        conveyance: 0,
        medicalAllowance: 0,
        specialAllowance: 0,
        bonus: 0,
        otherEarnings: 0,
        pf: 0,
        esi: 0,
        professionalTax: 0,
        incomeTax: 0,
        loanRepayment: 0,
        otherDeductions: 0,
        paymentDate: dayjs(selectedDate).set("date", 1),
        isPaid: false,
      }}
    >
      <Title level={4}>Employee Salary Form</Title>
      <div className="grid grid-cols-4 gap-2 items-center">
        <Form.Item
          label="Month"
          name="month"
          rules={[{ required: true, message: "Month is required" }]}
        >
          <DatePicker picker="month" style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item label="Payment Date" name="paymentDate">
          <DatePicker
            style={{ width: "100%" }}
            value={
              form?.getFieldValue("paymentDate")
                ? dayjs(form?.getFieldValue("paymentDate"))
                : null
            }
            onChange={(date) => form.setFieldsValue({ paymentDate: date })}
          />
        </Form.Item>
        <Form.Item name="isPaid" label="Is Paid">
          <Select
            options={[
              { label: "Yes", value: true },
              { label: "No", value: false },
            ]}
          ></Select>
        </Form.Item>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <div className="border p-2 rounded-md">
          <Title level={5}>Earnings</Title>
          <div className="grid grid-cols-2 gap-2">
            {earings.map((field) => (
              <Form.Item
                key={field.value}
                label={field.label}
                name={field.value}
                rules={[
                  {
                    type: "number",
                    min: 0,
                    message: "Value must be a number and greater than 0",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>
            ))}
          </div>
        </div>
        <div className="border p-2 rounded-md">
          <Title level={5}>Deductions</Title>
          <div className="grid grid-cols-2 gap-2">
            {deduction.map((field) => (
              <Form.Item
                key={field.value}
                label={field.label}
                name={field.value}
                rules={[
                  {
                    type: "number",
                    min: 0,
                    message: "Value must be a number and greater than 0",
                  },
                ]}
              >
                <InputNumber style={{ width: "100%" }} min={0} />
              </Form.Item>
            ))}
          </div>
        </div>
      </div>
    </Form>
  );
};
SalaryForm.propTypes = {
  data: PropTypes.object,
  selectedDate: PropTypes.string,
  form: PropTypes.any,
  isEdit: PropTypes.bool,
};

export default SalaryForm;
